<template>
  <dashboard>
    <template v-slot:content>
      <section class="gift-voucher">
        <b-container fluid>
          <div class="header-elements my-2 align-items-center">
            <b-row class="mt-2">
              <b-col lg="6" md="6">
                <b-row class="mt-1 align-items-center">
                  <b-col lg="7" md="7">
                    <div class="mt-1 d-flex align-items-baseline">
                      <h5>Gift Vouchers</h5>
                      <div class="total-amount d-flex ml-1">
                        <span
                          class="quantity h5 mb-0 text-muted"
                          v-text="`(${voucherDetails.length})`"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="5" md="5" class="cart-mode pr-0">
                    <div
                      class="total-items d-flex justify-content-between float-right"
                    >
                      <div class="d-flex ml-2">
                        Group View
                        <toggle-button
                          :width="40"
                          :value="state.giftVoucher.group_view"
                          :sync="true"
                          @change="
                            $store.commit(
                              'giftVoucher/setGroupView',
                              !state.giftVoucher.group_view
                            )
                          "
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="6" md="6">
                <b-input-group class="box-shadow">
                  <b-input-group-text slot="prepend" class="search-icon">
                    <font-awesome-icon :icon="['fas', 'search']" />
                  </b-input-group-text>
                  <!-- <b-form-input
                    v-model="search"
                    placeholder="Scan or search voucher code"
                    v-on:keyup.enter="searchbar"
                    class="search"
                    autocomplete="off"
                    :disabled="$loading"
                    v-shortkey.focus="['ctrl', 's']"
                    autofocus
                  ></b-form-input> -->
                  <b-form-input
                    v-model="search"
                    placeholder="Scan or search voucher code"
                    class="search"
                    autocomplete="off"
                    :disabled="$loading"
                    v-shortkey.focus="['ctrl', 's']"
                    autofocus
                  />
                </b-input-group>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section class="gift-voucher">
        <b-container fluid>
          <b-row>
            <!-- Cart Table -->
            <b-col lg="6" md="6" class="pr-0 fadein">
              <div class="box-shadow">
                <div class="table-dark-bg billing-table cart-table-wrapper">
                  <b-table
                    :fields="fields"
                    :items="voucherDetails"
                    v-if="voucherDetails.length > 0"
                    class="table cart-table mt-0 mb-0 table-dark"
                  >
                    <template v-slot:cell(#)="data" class="sticky">
                      {{ data.index + 1 }}
                    </template>
                    <template v-slot:cell(gv_group_name)="data">
                      <p
                        class="mb-1"
                        v-text="_.upperFirst(data.item.gv_group_name)"
                      ></p>
                      <span
                        class="text-muted"
                        v-text="_.upperFirst(data.item.gv_group_description)"
                      />
                    </template>
                    <template v-slot:cell(gift_value)="data">
                      <b-form-input
                        type="number"
                        v-model="data.item.gift_value"
                        v-negative-disable
                        @input="updateSaleValueFromCart(data.item)"
                        v-if="
                          !state.giftVoucher.group_view &&
                            data.item.value_type != 'Fixed'
                        "
                      />
                      <span
                        v-else
                        v-text="
                          currencySymbol +
                            parseFloat(data.item.gift_value).toFixed(2)
                        "
                      />
                    </template>
                    <template v-slot:cell(sale_value)="data">
                      <span
                        v-text="
                          currencySymbol +
                            parseFloat(data.item.sale_value).toFixed(2)
                        "
                      />
                    </template>
                    <template v-slot:cell(voucher_code)="data">
                      <span
                        v-text="helper.hideMiddleText(data.item.voucher_code)"
                      />
                    </template>
                    <template
                      v-slot:cell(quantity)="data"
                      v-if="state.giftVoucher.group_view"
                    >
                      <b-form-input
                        type="number"
                        v-model.lazy="data.item.quantity"
                        :disabled="data.item.value_type == 'Custom'"
                        :id="
                          `gv-${data.item.gv_group_id}-${data.item.value_type}-${data.item.sale_value_s}-${data.item.gift_value_s}`
                        "
                        v-max-qty.int.update-voucher="{
                          available: getAvailableQty(data.item.gv_group_id),
                        }"
                      ></b-form-input>
                    </template>
                    <template v-slot:cell(mobile)="data">
                      <b-link @click="openTagCustomerPhoneModal(data.item)"
                        ><img
                          v-show="checkEmpty(data.item.mobile)"
                          src="../assets/images/add_phone.svg"
                          alt=""
                        />
                        <img
                          v-show="!checkEmpty(data.item.mobile)"
                          src="../assets/images/phone_added.svg"
                          alt=""
                          v-b-tooltip.hover
                          :title="`Edit ${data.item.mobile}`"
                        />
                      </b-link>
                    </template>
                    <template v-slot:cell(actions)="data">
                      <b-link
                        class="text-muted text-center"
                        @click="
                          removeVoucher(
                            data.item,
                            !state.giftVoucher.group_view
                              ? 'individual_remove'
                              : 'remove_group'
                          )
                        "
                        ><font-awesome-icon :icon="['fas', 'times']"
                      /></b-link>
                    </template>
                  </b-table>
                  <div
                    v-else
                    class="d-flex align-items-center text-center"
                    style="height:90%"
                  >
                    <p class="text-muted mb-0 w-100">
                      Scan or select vouchers to add them to cart
                    </p>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col lg="6" md="6" class="fadein" v-show="isVisible">
              <b-row class="mt-2">
                <b-col md="6" lg="6" class="pl-0">
                  <div class="card mb-2 total-cart-amount box-shadow">
                    <div class="card-body p-0">
                      <div class="row sale align-items-center">
                        <div class="col light">
                          <p>Payable Amount</p>
                        </div>
                        <div class="col text-right">
                          <h6
                            class="mb-0"
                            v-text="
                              currencySymbol +
                                state.billing.billing.total_payable
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <gift-voucher-action-btns />
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="6" md="6" class="fadein">
              <div class="product-detail-wrapper"></div>
              <div class="clearfix"></div>

              <!-- Product information-->
              <voucher-group />
              <!-- Product information close-->

              <b-row class="mt-2">
                <b-col md="6" lg="6">
                  <customer-information />
                </b-col>

                <b-col md="6" lg="6" class="pl-0">
                  <div class="card mb-2 total-cart-amount">
                    <div class="card-body">
                      <div class="row">
                        <div class="col light">
                          <p class="t_amt d-lfex">Subtotal</p>
                        </div>
                        <div class="col text-right">
                          <p
                            v-text="
                              currencySymbol +
                                parseFloat(
                                  state.giftVoucher.cart.subtotal == '' ||
                                    state.giftVoucher.cart.subtotal == null
                                    ? '0'
                                    : state.giftVoucher.cart.subtotal
                                ).toFixed(2)
                            "
                          />
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col light">
                          <p
                            :class="
                              state.giftVoucher.cart.total_tax == null ||
                              state.giftVoucher.cart.total_tax == ''
                                ? 'text-muted'
                                : null
                            "
                            class="t_amt d-flex"
                          >
                            Taxes
                          </p>
                        </div>
                        <div class="col text-right">
                          <p
                            :class="
                              state.giftVoucher.cart.total_tax == null ||
                              state.giftVoucher.cart.total_tax == ''
                                ? 'text-muted'
                                : null
                            "
                            v-text="
                              currencySymbol + state.giftVoucher.cart.total_tax
                            "
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col light t_amt">
                          <p>Total Amount</p>
                        </div>
                        <div class="col text-right">
                          <h6
                            class="mb-0"
                            v-text="
                              currencySymbol +
                                parseFloat(
                                  state.giftVoucher.cart.total_amount == '' ||
                                    state.giftVoucher.cart.total_amount == null
                                    ? '0'
                                    : state.giftVoucher.cart.total_amount
                                ).toFixed(2)
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <gift-voucher-action-btns />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </section>

      <b-modal
        id="phone-voucher-modal"
        ref="phone-voucher-modal"
        hide-footer
        centered
        size="sm"
        no-close-on-backdrop
        title="Add Phone to Voucher"
      >
        <p class="text-muted">
          Adding a phone number will restrict the usage, i.e.
          redemption/recharge of selected voucher to the owner of the added
          number.
        </p>
        <label class="w-100 d-block">Enter Phone Number</label>
        <b-input-group
          class="mt-1 mb-4 inputgroup-withappends with-prepend"
          :class="mobile != '' ? 'active' : ''"
        >
          <b-form-input
            type="number"
            v-model="mobile"
            v-allow.phone.number
            placeholder="000 0000 000"
          ></b-form-input>
          <template #append>
            <b-input-group-text>
              <font-awesome-icon
                :icon="['fas', 'times']"
                class="cursor-p text-danger"
                @click="
                  unTagCustomerPhone(
                    !state.giftVoucher.group_view
                      ? 'remove_individual'
                      : 'remove_group'
                  ),
                    (mobile = '')
                "
            /></b-input-group-text>
          </template>
        </b-input-group>
        <div class="actions-links">
          <b-link
            class="mb-2 p-2 d-block fs-12"
            :disabled="tagBillingCustomerCond"
            @click="
              (mobile = state.billing.billing.customer.data.mobile),
                tagCustomerPhone('tag_individual')
            "
          >
            <font-awesome-icon :icon="['fas', 'user']" class="mr-2" />
            Use billing customer’s phone
          </b-link>
          <b-link
            class="mb-2 p-2 d-block fs-12"
            :disabled="applyToAllCond"
            @click="tagCustomerPhone('tag_cart')"
          >
            <font-awesome-icon :icon="['fas', 'list']" class="mr-2" />
            Apply to all vouchers in Cart
          </b-link>
          <!-- <b-link class="d-block p-2 fs-12 text-danger">
            <font-awesome-icon :icon="['fas', 'trash-alt']" class="mr-2" />
            Remove from other vouchers in Cart
          </b-link> -->
        </div>
        <b-row class="mt-4 align-items-center">
          <b-col md="12">
            <div class="d-flex w-100">
              <b-button
                class="mr-1"
                block
                variant="outline-primary"
                @click="$refs['phone-voucher-modal'].hide()"
                :disabled="$loading"
                >Cancel</b-button
              >
              <b-button
                class="ml-1"
                block
                variant="primary"
                :disabled="$loading || checkUpdatePhoneBtn"
                @click="
                  tagCustomerPhone(
                    !state.giftVoucher.group_view
                      ? 'tag_individual'
                      : 'tag_group'
                  )
                "
              >
                <span v-if="!$loading">Update</span>
                <b-spinner small v-if="$loading" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import GiftVoucherActionBtns from "../components/GiftVoucherActionBtns";
import CustomerInformation from "../components/CustomerInformation";
import VoucherGroup from "../components/VoucherGroup";
import * as helper from "../helper";
import * as msg from "../message";
import _ from "lodash";

import { mapState } from "vuex";
export default {
  name: "gift-vouchers",
  components: {
    Dashboard,
    GiftVoucherActionBtns,
    VoucherGroup,
    CustomerInformation,
  },
  props: ["newValue"],
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    helper() {
      return helper;
    },
    _() {
      return _;
    },
    fields() {
      let temp = [
        { key: "#", label: "#", class: "text-center" },
        { key: "voucher_sequence", label: "Pack/Sequence" },
        { key: "voucher_code", label: "Voucher Code" },
        { key: "sale_value", label: "Sale Value" },
        { key: "gift_value", label: "Gift Value", class: "w-15" },
        { key: "mobile", label: "Phone" },
        { key: "actions", label: "", class: "text-center" },
      ];
      if (this.state.giftVoucher.group_view)
        temp = [
          { key: "#", label: "#", class: "text-center" },
          { key: "gv_group_name", label: "Voucher Group" },
          { key: "sale_value", label: "Sale Amount" },
          { key: "quantity", label: "Quantity", class: "w-15" },
          { key: "mobile", label: "Phone" },
          { key: "actions", label: "", class: "text-center" },
        ];
      return temp;
    },
    voucherDetails() {
      let temp = this.state.giftVoucher.cart.cart_details;
      if (this.state.giftVoucher.group_view)
        temp = this.state.giftVoucher.cart.group_cart_details;
      return temp;
    },
    checkUpdatePhoneBtn() {
      let temp = true;
      if (this.mobile.length == this.state.system.country_details.phone_digit)
        temp = false;
      return temp;
    },
    tagBillingCustomerCond() {
      let temp = false;
      if (
        !this.state.billing.billing.customer.data.hasOwnProperty("mobile") ||
        this.voucherData.mobile ==
          this.state.billing.billing.customer.data.mobile
      )
        temp = true;
      return temp;
    },
    applyToAllCond() {
      let temp = false;
      if (
        this.mobile == "" ||
        this.mobile == null ||
        this.state.giftVoucher.cart.cart_details.length <= 1
      )
        temp = true;
      if (this.mobile.length != this.state.system.country_details.phone_digit)
        temp = true;

      let count = 0;
      this.state.giftVoucher.cart.cart_details.forEach((item) => {
        if (item.mobile == this.mobile) count++;
      });
      if (count == this.state.giftVoucher.cart.cart_details.length) temp = true;
      return temp;
    },
  },
  beforeDestroy() {
    this.$store.commit("giftVoucher/setGroupView", false);
    this.$store.commit("giftVoucher/clearVoucherGroups");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        from.name == "billing" &&
        !vm.$root.checkEmpty(vm.state.billing.billing.customer.data.c_id)
      )
        vm.$store.commit("billing/newBilling");
    });
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name == "billing" &&
      !this.checkEmpty(this.state.billing.billing.customer.data.c_id)
    )
      this.$store.commit("billing/removeCustomer");
    next();
  },
  mounted() {
    this.$store.dispatch("giftVoucher/cartDetails");
    this.$store.commit("giftVoucher/setGvSale", false);
  },
  data() {
    return {
      NumOfItems: 0,
      amount: 0,
      isVisible: false,
      search: "",
      toggleGroup: false,
      mobile: "",
      voucherData: {},
    };
  },
  methods: {
    removeVoucher(item, action_type) {
      this.$loading = true;
      let data = {
        selected: [item],
        gv_group_id: item.gv_group_id,
        action_type: action_type,
      };
      this.$store
        .dispatch("giftVoucher/cartActions", data)
        .then(() => {
          this.$loading = false;
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", {
            message:
              action_type == "individual_remove"
                ? msg.VOUCHER_REMOVED
                : msg.VOUCHER_GROUP_REMOVED,
            type: "success",
          });
        })
        .catch(() => (this.$loading = false));
    },
    updateGroupQty(item) {
      this.$store
        .dispatch("giftVoucher/cartActions", {
          gv_group_id: item.gv_group_id,
          selected: [],
          action_type: "group_qty_update",
          bulk_qty: item.quantity,
          value_type: item.value_type,
          sale_value: item.sale_value,
          gift_value: item.gift_value,
        })
        .then((res) => {
          if (res.data.status != "fail") {
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message: msg.VOUCHER_QTY_UPDATE,
              type: "success",
            });
          }
        });
    },
    updateSaleValueFromCart: _.debounce(function(item) {
      this.$store
        .dispatch("giftVoucher/cartActions", {
          gv_id: item.gv_id,
          voucher_code: item.voucher_code,
          selected: [],
          gv_group_id: item.gv_group_id,
          action_type: "sale_value_update",
          gift_value: item.gift_value,
        })
        .then((res) => {
          if (res != undefined && res.data.status != "fail") {
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message: msg.VOUCHER_SALE_VALUE_UPDATE,
              type: "success",
            });
          }
        });
    }, 200),
    openTagCustomerPhoneModal(item) {
      this.voucherData = item;
      this.mobile =
        item.mobile == null || item.mobile == "0" ? "" : item.mobile;
      this.$refs["phone-voucher-modal"].show();
    },
    tagCustomerPhone(action_type) {
      this.$loading = true;
      let data = {
        action_type: action_type,
        gv_group_id: this.voucherData.hasOwnProperty("gv_group_id")
          ? this.voucherData.gv_group_id
          : 0,
        customer_mobile: this.mobile,
      };
      if (this.voucherData.hasOwnProperty("gv_id"))
        data.gv_id = this.voucherData.gv_id;
      this.$store
        .dispatch("giftVoucher/tagCustomerToGv", data)
        .then((res) => {
          this.$loading = false;
          if (res.data.status != "fail") {
            this.$refs["phone-voucher-modal"].hide();
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message: msg.VOUCHER_MOBILE_TAG,
              type: "success",
            });
          }
        })
        .catch(() => (this.$loading = false));
    },
    unTagCustomerPhone(action_type) {
      if (this.voucherData.mobile == null) return;
      this.$loading = true;
      this.$store
        .dispatch("giftVoucher/tagCustomerToGv", {
          action_type: action_type,
          gv_group_id: this.voucherData.gv_group_id,
          gv_id: this.voucherData.gv_id,
          customer_mobile: this.mobile,
        })
        .then((res) => {
          this.$loading = false;
          if (res.data.status != "fail") {
            this.$refs["phone-voucher-modal"].hide();
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", {
              message: msg.VOUCHER_MOBILE_UNTAG,
              type: "success",
            });
          }
        })
        .catch(() => (this.$loading = false));
    },
    getAvailableQty(gv_group_id) {
      let temp = 10;
      this.state.giftVoucher.groups.group_list.forEach((item) => {
        if (item.gv_group_id == gv_group_id)
          temp = parseInt(item.available_voucher);
      });
      return temp;
    },
  },
};
</script>
<style lang="scss" scoped>
.actions-links a:hover {
  background: $grey-10;
  border-radius: 4px;
}
@include keyframes(fadein) {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadein {
  @include animation("fadein 1s");
}
@include keyframes(fadeout) {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeout {
  @include animation("fadeout 1s");
}
.header-elements {
  .total-amount {
    color: #404040;
    .quantity {
      font-size: 1.2rem;
      margin-top: -2px;
    }
  }
}
.theme-dark .header-elements {
  .total-amount {
    color: #c0c0c0;
    span {
      font-size: 1.2rem;
      margin-top: -2px;
    }
  }
}
.product-catalog-wrapper .total-cart-amount .card-body {
  padding: 2rem 0.75rem;
}
.sale {
  padding: 2rem 0.75rem;
}
.total-cart-amount p {
  margin: 4px 0px;
}
.vue-js-switch {
  margin: 0;
  margin-left: 7px;
}
</style>
